import React from 'react';

import './ErrorMessages.css';

const ErrorMessages = ({ errorsTitle, errors, currentErrors }) => {
  return (
    <div className='errors-container'>
      <ul id='mutliple-error-messages-container'>
        <p className='errors-title'>{errorsTitle}</p>
        {errors.map((err, i) => {
          const isFixed = !currentErrors.includes(err);
          return (
            <li
              key={i}
              className='single-error-message-container'
              style={{ color: isFixed ? 'green' : 'red', width: '100%' }}
            >
              {isFixed ? '✓' : '✗'} {err}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ErrorMessages;
